<template>
  <div id="contenedor-eliminar-auditoria-contrato">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Contrato de la Auditoría </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el Contrato? </span>
        <v-divider></v-divider>
        <v-row>
          <span class="font-weight-bold">
            {{auditoriaContratosEliminar.contrato.numero}}
          </span>
        </v-row>
        <v-row>
          <span> <cortar-texto
          :texto="auditoriaContratosEliminar.contrato.meta">
          </cortar-texto>
          </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="botonEliminarAuditoriaContrato"
          :disabled="enviandoFormulario || $apollo.loading"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import mixContratos from './mixContratos';
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ContenedorEliminarAuditoriaContrato',
  props: {
    auditoriaContratosEliminar: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixContratos],
  components: {
    CustomButton,
    CortarTexto,
  },
  data() {
    return {
      enviandoFormulario: false,
      contrato: this.auditoriaContratosEliminar,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    botonEliminarAuditoriaContrato() {
      this.enviandoFormulario = true;
      this.mixEliminarAuditoriaContrato();
    },
  },
  computed: {
  },
};
</script>
